export const OnePayEventNames = {
  onePayLanding: 'OnePay - PageView',
  onePayAPIError: 'OnePay - APIError',
  externalScriptLoaded: 'ExternalScript - Loaded',
  externalScriptFailed: 'ExternalScript - Failed',
  sessionExpiredModal: 'OnePay - SessionExpiredModalView',
  razorPayFailed: 'Razorpay - Failed',
  adyenCCFormFailed: 'AdyenCC - FormFailed',
  adyenCCFormError: 'AdyenCC - FormError',
  adyenCCPaymentFailed: 'AdyenCC - PaymentFailed',
  adyenACHFormFailed: 'AdyenACH - FormFailed',
  adyenACHFormError: 'AdyenACH - FormError',
  adyenACHPaymentFailed: 'AdyenACH - PaymentFailed',
};

export const PaymentMethodEventNames = {
  // Payment methods events
  paymentMethodLanding: 'Payment methods - PageView',
  paymentMethodBackToG2A: 'Payment methods - BackToG2AClick',

  // Credit card events
  prepareCCResponse: 'Credit Card - PrepareResponse',
  creditCardSaveCTA: 'Credit Card - SaveClick',

  // ACH events
  prepareACHResponse: 'ACH - PrepareResponse',
  achSaveCTA: 'ACH - SaveClick',

  // Direct debit events
  directDebitCTA: 'DirectDebit - SaveClick',

  // PayPal events
  paypalSaveStep1: 'Paypal - SaveStep1',
  paypalSaveRedirect: 'Paypal - SaveRedirect',
};

export const PayNowEventNames = {
  paynowLanding: 'Paynow - PageView',
  paynowBackToCheckout: 'Paynow - BackToCheckoutClick',
  delete: 'PayNow - DeleteClick',
  setDefault: 'PayNow - SetDefaultClick',
  paynowAddNewMethod: 'Paynow - AddNewPaymentMethodClick',
  paynowContinueAddNewMethod: 'Paynow - ContinueAddNewMethodClick',
  paynowCTA: 'Paynow - PayClick',
  paynowSaveAndPay: 'Paynow - SaveAndPayClick',
};

export const GAEventNames = {
  ViewContent: 'view_content',
  ClickCTA: 'click_cta',
  PurchaseError: 'error_purchase',
  PAYMENT_FAILED: 'Payment failed',
  PROVISIONING_FAILED: 'Provisioning failed',
};
